import { FETCH_AUCTION, ADD_AUCTION, DELETE_AUCTION, DESTROY_AUCTION } from '../actionTypes';
import { AUCTION } from '../config/index';

const getItems = (state = [], action) => {
    switch (action.type) {
        
        case FETCH_AUCTION:
            state = [];
            return [ ...state, ...action.auctions];
        
        case ADD_AUCTION:
            let currentState;
            if(AUCTION.LIMIT === state.length){
                state.pop();
                currentState = state;
            } else {
             currentState = state;
            }
                
            return [action.payload, ...currentState];
        
        case DELETE_AUCTION:
           return state.filter((item) => {
                return item.id !== action.auction.id;
            });
        
        case DESTROY_AUCTION:
            return state[action.key] = [];

        default:
            return state;
    }

};

export default getItems;